export default __webpack_public_path__ + "static/media/arrow-right.4e288eb0.svg";